<template>
    <div class="user-profile">
        USER
    </div>
</template>

<script>
export default {
    data () {
        return {
            
        }
    }
}
</script>

<style scoped>
.user-profile{
	color: #FFFFFF;
	display: inline-block;
	position: absolute;
	right: 20px;
}
</style>